module.exports = __webpack_public_path__ + "img/section_2-svg_1.6d8d394e.svg";